module.exports = __webpack_public_path__ + "img/queen.0d3bd653.jpeg";